// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// FontAwesome
import { registerFontAwesome } from './plugins/fontawesome'

// Vuetify
import { createThemedVuetify } from './plugins/vuetify'

import '@/assets/styles/global.css'

// CKEditor do VUe
import '@vueup/vue-quill/dist/vue-quill.snow.css'

// Cria app Vue
const app = createApp(App)

// Configurações de segurança e endpoint (do .env)
const chaveSeguranca = process.env.VUE_APP_CHAVE_SEGURANCA
const endpoint = process.env.VUE_APP_BASE_ENDPOINT
const apiKeyMaps = process.env.VUE_APP_GOOGLE_KEY
const cidadeCliente = process.env.VUE_APP_CIDADE_CLIENTE
const estadoCliente = process.env.VUE_APP_ESTADO_CLIENTE
const lat = process.env.VUE_APP_LAT
const long = process.env.VUE_APP_LONG
const usuarioSeguranca = {
  user: process.env.VUE_APP_USUARIO,
  password: process.env.VUE_APP_PASSWORD
}

const bibliotecasAcao = {
  MANOBRAS: process.env.VUE_APP_BIBLIOTECA_MANOBRAS,
  PAVIMENTACAO: process.env.VUE_APP_BIBLIOTECA_PAVIMENTACAO,
  HIDROMETRO_RETIRADO: process.env.VUE_APP_BIBLIOTECA_HIDROMETRO_RETIRADO,
  MATERIAIS: process.env.VUE_APP_BIBLIOTECA_MATERIAIS,
  DESCARGAS: process.env.VUE_APP_BIBLIOTECA_DESCARGAS,
  UPLOAD_FOTOS: process.env.VUE_APP_BIBLIOTECA_UPLOAD_FOTOS,
  MAQUINARIO: process.env.VUE_APP_BIBLIOTECA_MAQUINARIO,
  UPLOAD_FOTO_1: process.env.VUE_APP_BIBLIOTECA_UPLOAD_FOTO_1,
  REDE_AGUA: process.env.VUE_APP_BIBLIOTECA_REDE_AGUA,
  FUNCIONARIOS: process.env.VUE_APP_BIBLIOTECA_FUNCIONARIOS,
  EXECUCAO: process.env.VUE_APP_BIBLIOTECA_EXECUCAO,
  ARQUIVOS: process.env.VUE_APP_BIBLIOTECA_ARQUIVOS,
  HIDROMETRO_COLOCADO: process.env.VUE_APP_BIBLIOTECA_HIDROMETRO_COLOCADO,
  REDE_ESGOTO: process.env.VUE_APP_BIBLIOTECA_REDE_ESGOTO
}

const tiposObservacao = {
  CRIACAO: process.env.VUE_APP_TIPO_OBS_CRIACAO,
  CANCELAMENTO: process.env.VUE_APP_TIPO_OBS_CANCELAMENTO,
  DEVOLUCAO: process.env.VUE_APP_TIPO_OBS_DEVOLUCAO,
  ENCERRAMENTO: process.env.VUE_APP_TIPO_OBS_ENCERRAMENTO,
  COMPLEMENTAR: process.env.VUE_APP_TIPO_OBS_COMPLEMENTAR,
  EDICAO: process.env.VUE_APP_TIPO_OBS_EDICAO,
}

// Injeta valores globais via provide
app.provide('chaveSeguranca', chaveSeguranca)
app.provide('endpoint', endpoint)
app.provide('headerPadrao', { 'Content-Type': 'application/json' })
app.provide('usuarioSeguranca', usuarioSeguranca)
app.provide('apiKeyMaps', apiKeyMaps)
app.provide('cidadeCliente', cidadeCliente)
app.provide('estadoCliente', estadoCliente)
app.provide('bibliotecasAcao', bibliotecasAcao)
app.provide('tiposObservacao', tiposObservacao)
app.provide('lat', lat)
app.provide('long', long)

// Exposição via globalProperties (this.$...)
app.config.globalProperties.$chaveSeguranca = chaveSeguranca
app.config.globalProperties.$endpoint = endpoint
app.config.globalProperties.$headerPadrao = { 'Content-Type': 'application/json' }
app.config.globalProperties.$usuarioSeguranca = usuarioSeguranca
app.config.globalProperties.$grupoDestinatarioGeoreferenciado = 1;
app.config.globalProperties.$grupoDestinatarioPadrao = 2;
app.config.globalProperties.$grupoDestinatarioManual = 3;
app.config.globalProperties.$bibliotecasAcao = bibliotecasAcao;
app.config.globalProperties.$tipoObservcao = tiposObservacao;

// Registro global do componente FontAwesome
registerFontAwesome(app)

// Instância Vuetify com tema dinâmico (light/dark) conforme armazenamento
const themeMode = localStorage.getItem('themeMode') || 'light'
const vuetify = createThemedVuetify(themeMode)

// Uso de plugins e montagem do app
app
  .use(router)
  .use(vuetify)
  .mount('#app')
